import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { ConversationDetailTabs } from 'src/core/models/conversation-detail-tabs';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { CADatePipe } from 'src/core/pipes/ca-date.pipe';
import { NotificationService } from 'src/core/services/notification/notification.service';
import { CAToasterHelperService } from 'src/core/services/toaster/ca-toaster-helper.service';

@Component({
  selector: 'ca-conversation-comment-mention-notification',
  templateUrl: './conversation-comment-mention-notification.component.html',
  styleUrl: './conversation-comment-mention-notification.component.scss',
  standalone: false,
})
@NotificationType(
  'ConversationCommentMentionNotification',
  ConversationCommentMentionNotificationComponent,
)
export class ConversationCommentMentionNotificationComponent {
  data: NotificationDto;
  conversationDetailTabs = ConversationDetailTabs;

  get payloadData(): any {
    return JSON.parse(this.data?.payload);
  }

  constructor(
    private notificationService: NotificationService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService,
    toasterHelperService: CAToasterHelperService,
    notificationService: NotificationService,
    injector: Injector,
    caDatePipe: CADatePipe,
    router: Router,
  ) {
    const parsedPayload = JSON.parse(payload);
    const message = localizationService.instant(
      'Conversation::ConversationCommentMentionNotificationMessage',
      parsedPayload.conversationId,
    );
    var toastrId = toastr.info(message);

    var toastrInstance = toasterHelperService.getToastById(toastrId);
    toastrInstance.onTap.pipe(take(1)).subscribe(() => {
      this.toasterClickedHandler(
        notificationService,
        notificationId,
        parsedPayload,
        router,
        ConversationDetailTabs.comment,
      );
    });
  }

  static toasterClickedHandler(
    notificationService: NotificationService,
    notificationId: string,
    payload: any,
    router: Router,
    activeTab: string,
  ) {
    notificationService.markAsRead(notificationId).subscribe();
    this.navigateToConversation(payload, router, activeTab);
    notificationService.markAsRead(notificationId);
  }

  static navigateToConversation(payloadData: any, router: Router, activeTab: string) {
    const queryParams: any = {
      activeTab: activeTab,
    };

    router.navigate(['/conversation/v2', payloadData.conversationId], {
      queryParams: queryParams,
    });
  }

  onClick() {
    const parsedPayload = JSON.parse(this.data.payload);
    ConversationCommentMentionNotificationComponent.navigateToConversation(
      parsedPayload,
      this.router,
      this.conversationDetailTabs.comment,
    );
    this.notificationService.markAsRead(this.data.id);
  }
}
